import EonOneIntegrations from '@/components/eon-one/integrations';

export default function EonOneIntegrationsScreen() {
  return <EonOneIntegrations />;
}
